import { WebsocketMessageType } from "./websocket-message-type";
import { GameTasks } from "../game/game-tasks";
import gameApplication from "../game/game-app";

/**
 * This is used to process incoming websocket messages from the  Java server client.
 *
 * Messages are routed to the "task" methods.
 * These "task" methods are similar to the original Java applet tasks classes.
 */
class WebsocketProcessor {
  private gameTasks: GameTasks;

  constructor() {
    this.gameTasks = new GameTasks();
  }

  /**
   * This processes the incoming Websocket messages.
   * ENTER_ROOM_CONFIRM is not processed here as this is processesd in the REST API.
   *
   * @param message - Websocket data
   */
  public processMessage(message: string) {
    const wsMessage: any = JSON.parse(message);
    const msgType = wsMessage.msgType;
    const sender = wsMessage.sender;
    
    // Don't send game messages to the sender of the game message except chat messages.
    if (sender !== undefined && sender.playerId != null) {
      if (wsMessage.sender.getPlayerId === gameApplication.getPlayer().player.playerId) {
        if (wsMessage.msgType !== WebsocketMessageType.CHAT_MSG) {
          // pass only messages from other users
          return;
        }
      }
    }

    switch (msgType) {
      case WebsocketMessageType.PLAYER_LIST: {
        this.gameTasks.playerListTask(wsMessage);
        break;
      }
      case WebsocketMessageType.LIST_ROOMS_RESPONSE: {
        this.gameTasks.listRoomsTask(wsMessage);
        break;
      }
      case WebsocketMessageType.USER_ADDED: {
        this.gameTasks.userAddedTask(wsMessage);
        break;
      }
      case WebsocketMessageType.USER_REMOVED: {
        this.gameTasks.userRemovedTask(wsMessage);
        break;
      }
      case WebsocketMessageType.CHAT_MSG: {
        this.gameTasks.chatMessageTask(wsMessage);
        break;
      }
      case WebsocketMessageType.NEW_GAME_INVITE: {
        this.gameTasks.newGameInviteTask(wsMessage);
        break;
      }
      case WebsocketMessageType.INVITE_STATUS: {
        this.gameTasks.inviteStatusTask(wsMessage);
        break;
      }
      case WebsocketMessageType.START_GAME: {
        this.gameTasks.startGameTask(wsMessage);
        break;
      }
      case WebsocketMessageType.GAME_ADDED: {
        this.gameTasks.gameAddedTask(wsMessage);
        break;
      }
      case WebsocketMessageType.GAME_REMOVED: {
        this.gameTasks.gameRemovedTask(wsMessage);
        break;
      }
      case WebsocketMessageType.HIT_POWER: {
        this.gameTasks.hitPowerAdjustTask(wsMessage);
        break;
      }
      case WebsocketMessageType.HIT_POINT: {
        this.gameTasks.hitPointAdjustTask(wsMessage);
        break;
      }
      case WebsocketMessageType.HIT_DIRECTION: {
        this.gameTasks.hitDirectionAdjustTask(wsMessage);
        break;
      }
      case WebsocketMessageType.HIT_CUE_BALL: {
        this.gameTasks.hitCueBallTask(wsMessage);
        break;
      }
      case WebsocketMessageType.DISCARD_GAME: {
        this.gameTasks.discardGameTask(wsMessage);
        break;
      }
      case WebsocketMessageType.GAME_USER_ADDED: {
        this.gameTasks.gameUserAddedTask(wsMessage);
        break;
      }
      case WebsocketMessageType.GAME_USER_REMOVED: {
        this.gameTasks.gameUserRemovedTask(wsMessage);
        break;
      }
      case WebsocketMessageType.CUE_POSITION: {
        this.gameTasks.cueBallPositionTask(wsMessage);
        break;
      }
      case WebsocketMessageType.GAME_MESSAGE: {
        this.gameTasks.gameActionTask(wsMessage);
        break;
      }
      case WebsocketMessageType.PASS_BACK: {
        this.gameTasks.passBackTask(wsMessage);
        break;
      }
      case WebsocketMessageType.TOURNAMNET_INVITE: {
        this.gameTasks.tournamentInviteTask(wsMessage);
        break;
      }
      case WebsocketMessageType.TOURNAMNET_SIGNUP_RESULT: {
        this.gameTasks.tournamentJoinResultTask(wsMessage);
        break;
      }
      case WebsocketMessageType.TOURNAMENT_ACCEPT_RESULT: {
        this.gameTasks.tournamentAcceptResultTask(wsMessage);
        break;
      }
      case WebsocketMessageType.TOURNAMENT_GAME_MESSAGE: {
        this.gameTasks.tournamentJoinStatusTask(wsMessage);
        break;
      } 
      case WebsocketMessageType.USER_UPDATE: {
        this.gameTasks.userUpdateTask(wsMessage);
        break;
      }
      case WebsocketMessageType.USER_CREDIT_UPDATE: {
        this.gameTasks.userCreditUpdateTask(wsMessage);
        break;
      }
      case WebsocketMessageType.MATCH_END: {
        this.gameTasks.matchEndTask(wsMessage);
        break;
      }  
      case WebsocketMessageType.SYNCHRONIZE_GAME: {
        this.gameTasks.synchronizeGameTask(wsMessage);
        break;
      }
      case WebsocketMessageType.ERROR_MESSAGE: {
        this.gameTasks.errorTask(wsMessage);
        break;
      }
      default: {
        break;
      }
    }
  }
}

const websocketProcessor = new WebsocketProcessor();

export default websocketProcessor;
